import { Configuration } from "@interface48/api";
import { FileDetails, FilePicker, FilePickerOptions } from "@interface48/form-controls";
import { formatFileSize } from "@interface48/formatting";
import FormControl from "@material-ui/core/FormControl";
import React from "react";
import { Error, Help, Label } from "../../templates";
import { ReadOnlyField } from "./ReadOnlyField";

const getFileDescription = (fileName: string, fileSizeBytes: number) => {
  return `${fileName!} (${formatFileSize(fileSizeBytes!)})`;
};

interface FileFieldProps {
  id: string;
  label?: string;
  required: boolean;
  readOnly: boolean;
  fileDetails?: FileDetails;
  options: FilePickerOptions;
  help?: string;
  errors: string[];
  getApiConfiguration?: () => Promise<Configuration>;
  onChange: (fileUploadId: string, fileDetails: { fileName: string; fileSizeBytes: number }) => void;
  onBlur: () => void;
}

export const FileFieldComponent = (props: FileFieldProps) => {
  const {
    id,
    label,
    required,
    readOnly,
    fileDetails,
    options,
    help,
    errors,
    getApiConfiguration,
    onChange,
    onBlur,
  } = props;

  return !readOnly ? (
    <FormControl error={!!errors.length} fullWidth={true} margin="normal" onBlur={onBlur}>
      {label && <Label fieldId={id} label={label} required={required} shrinkLabel={true} />}
      <FilePicker
        id={id}
        fileDetails={fileDetails}
        errors={errors}
        getApiConfiguration={getApiConfiguration}
        options={options}
        onChange={onChange}
      />
      <Error fieldId={id} errors={errors} />
      {help && <Help fieldId={id} help={help} />}
    </FormControl>
  ) : (
    // Shall we make the FilePicker have a readOnly mode itself?
    <ReadOnlyField id={id} label={label} margin="dense" errors={errors}>
      {fileDetails && fileDetails.fileName && fileDetails.fileSizeBytes
        ? getFileDescription(fileDetails.fileName, fileDetails.fileSizeBytes)
        : "(None)"}
    </ReadOnlyField>
  );
};

export const FileField = FileFieldComponent;
